import React from 'react';
import { Building2, GraduationCap, Heart, ShoppingBag, Home, Briefcase, Factory, Wrench } from 'lucide-react';
import { clients } from '../data/mock';

export const Clients = () => {
  const clientIcons = [
    Building2, Heart, GraduationCap, ShoppingBag, 
    Home, Briefcase, Factory, Wrench
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Clients, <span className="text-blue-600">Our Pride</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trusted by leading businesses across diverse industries
          </p>
        </div>

        {/* Clients Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          {clients.map((client, index) => {
            const Icon = clientIcons[index];
            return (
              <div 
                key={index}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 text-center group"
              >
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-600 transition-colors">
                  <Icon className="text-blue-600 group-hover:text-white transition-colors" size={32} />
                </div>
                <h3 className="text-sm font-semibold text-gray-700 group-hover:text-blue-600 transition-colors">
                  {client}
                </h3>
              </div>
            );
          })}
        </div>

        {/* Testimonial / Trust Section */}
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border-t-4 border-blue-600">
          <div className="text-center max-w-3xl mx-auto">
            <div className="text-6xl text-blue-600 mb-4">"</div>
            <p className="text-2xl text-gray-700 leading-relaxed mb-6 italic">
              Connect with us for better future
            </p>
            <p className="text-lg text-gray-600 mb-8">
              Let's Grow Together. We help businesses capture the right audience with data-driven strategies, 
              powerful designs, and perfect messaging for higher customer attention.
            </p>
            <div className="flex justify-center items-center gap-8">
              <div>
                <div className="text-3xl font-bold text-blue-600">500+</div>
                <div className="text-sm text-gray-600">Happy Clients</div>
              </div>
              <div className="w-px h-12 bg-gray-300"></div>
              <div>
                <div className="text-3xl font-bold text-blue-600">100%</div>
                <div className="text-sm text-gray-600">Satisfaction Rate</div>
              </div>
              <div className="w-px h-12 bg-gray-300"></div>
              <div>
                <div className="text-3xl font-bold text-blue-600">17+</div>
                <div className="text-sm text-gray-600">Years Trusted</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
